export default __webpack_public_path__ + "static/media/mana2w.b13c1bd4.svg";